import React, { useState } from 'react';

// Hinzufügen von onPasswordReset zur Destrukturierung
const AuthModal = ({ isOpen, onClose, onRegister, onLogin, setNotification, initialMode = 'login', onPasswordReset }) => {
  const [mode, setMode] = useState(initialMode);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false); // NEUER ZUSTAND: Passwort-Reset-Modus

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // NEU: Unterscheidung zwischen Reset-Modus und Login/Register-Modus
    if (isResetMode) {
      // WICHTIG: Ruft den dedizierten Reset-Handler auf und gibt den Flow sofort ab
      await handlePasswordReset(); 
      return; 
    }

    // --- Login / Registrierung ---
    try {
      if (mode === 'login') {
        await onLogin(email, password);
      } else {
        await onRegister(email, password);
      }
      // Das Schließen des Modals wird von der App.js gesteuert
    } catch (error) {
      // Fehler wird von App.js/onLogin/onRegister gesetzt
      setNotification({ message: `Fehler: ${error.message}`, type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setNotification({ message: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um das Passwort zurückzusetzen.', type: 'info' });
      setIsLoading(false);
      return;
    }
    
    setIsLoading(true);
    
    try {
        // NUTZT DIE VON APP.JS ÜBERGEBENE FUNKTION
        const result = await onPasswordReset(email);
        
        if (result.success) {
          // Bei Erfolg: Modal schliessen (App.js hat Benachrichtigung gesetzt)
          onClose(); 
        } else {
          // Bei Fehler (z.B. Benutzer existiert nicht): Bleibt im Reset-Modus, zeigt Fehler von App.js an
          setIsResetMode(true); 
          setPassword(''); 
        }
    } catch (error) {
        // Sollte nicht hierher gelangen, da App.js den Fehler fängt und notification setzt, 
        // aber als Fallback falls die onPasswordReset-Funktion fehlschlägt:
        setNotification({ message: `Fehler beim Senden: ${error.message}`, type: 'error' });
    } finally {
        setIsLoading(false); // <-- Setzt isLoading immer zurück
    }
  };
  
  const handleResetLinkClick = () => {
      setIsResetMode(true);
      setMode('login'); // Sicherstellen, dass der Login-Mode aktiv ist
      setPassword(''); // Passwortfeld leeren
  };
  
  const handleBackToLogin = () => {
      setIsResetMode(false);
      setPassword('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-2xl w-full max-w-md relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-red-500 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
        <h2 className="text-2xl font-bold mb-6 text-center">
            {isResetMode ? 'Passwort zurücksetzen' : (mode === 'login' ? 'Anmelden' : 'Registrieren')}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input 
            type="email" 
            id="email"
            name="email"
            autoComplete="email"
            placeholder="E-Mail" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className="w-full px-4 py-2 border rounded-lg" 
            required 
          />
          {/* Passwortfeld nur anzeigen, wenn NICHT im Reset-Modus und NICHT im Register-Modus */}
          {!isResetMode && mode === 'login' && (
              <input 
                type="password" 
                id="password"
                name="password"
                autoComplete="current-password"
                placeholder="Passwort" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className="w-full px-4 py-2 border rounded-lg" 
                required 
              />
          )}
          {mode === 'register' && (
              <input 
                type="password" 
                id="password"
                name="password"
                autoComplete="new-password"
                placeholder="Passwort" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className="w-full px-4 py-2 border rounded-lg" 
                required 
              />
          )}

          <button 
            type="submit" 
            disabled={isLoading} 
            className={`w-full px-4 py-3 text-white font-bold rounded-lg transition-colors ${isLoading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            {isLoading 
                ? 'Wird geladen...' 
                : (isResetMode 
                    ? 'Passwort-E-Mail senden' 
                    : (mode === 'login' ? 'Anmelden' : 'Registrieren')
                )
            }
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          {isResetMode ? (
              <button onClick={handleBackToLogin} className="text-gray-600 dark:text-gray-400 hover:underline">
                  Zurück zum Login
              </button>
          ) : (
              mode === 'login' ? (
                <>
                  <button onClick={handleResetLinkClick} className="text-blue-600 dark:text-blue-400 hover:underline">
                    Passwort vergessen?
                  </button>
                  <p className="mt-2">
                    Noch kein Konto?{' '}
                    <button onClick={() => setMode('register')} className="font-bold hover:underline">
                      Registrieren
                    </button>
                  </p>
                </>
              ) : (
                <p>
                  Bereits ein Konto?{' '}
                  <button onClick={() => setMode('login')} className="font-bold hover:underline">
                    Anmelden
                  </button>
                </p>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
